import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { usePathname, useSearchParams } from 'next/navigation';

export const useVariationFormattedLink = () => {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { language, localizeUrl } = useI18n();

  const createLink = (sku: string) => {
    const newSearchParams = new URLSearchParams(searchParams?.toString());

    if (sku) {
      newSearchParams.set('sku', sku);
    }
    return localizeUrl(`${pathname}?${newSearchParams.toString()}`, language);
  };

  return createLink;
};
